import React, { useState } from "react";
import Clienthomemenu from "../Menus/Clienthomemenu";

const Setftestexammodule = ({ questions }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!questions || questions.length === 0) {
    return (
      <>
        <Clienthomemenu title="EasyITI" testhistory="testhistory" />
        <div className="container text-center mt-4">
          <h5>No questions found</h5>
        </div>
      </>
    );
  }

  const currentQ = questions[currentIndex];

  return (
    <>
      <Clienthomemenu title="EasyITI" testhistory="testhistory" />

      {/* ===== MAIN CONTENT ===== */}
      <div className="container d-flex justify-content-center p-0" style={{ height: "auto" }}>
        <div className="card w-100 shadow" style={{ maxWidth: 900 }}>
          
          {/* HEADER */}
          <div className="card-header bg-dark text-white py-2">
            Question {currentIndex + 1} / {questions.length}
          </div>

          {/* BODY */}
          <div className="card-body">
            <h5 className="mb-3">{currentQ.QUESTION}</h5>

            {["A", "B", "C", "D"].map((opt, i) => (
              <div
                key={opt}
                className={`border p-2 rounded mb-2 ${
                  opt === currentQ.RIGHT_ANS
                    ? "bg-success text-white"
                    : ""
                }`}
              >
                {opt}. {currentQ[`OPT${i + 1}`]}
              </div>
            ))}

            <div className="alert alert-success py-2 mt-3">
              ✅ <b>Correct Answer :</b> {currentQ.RIGHT_ANS}
            </div>
          </div>

          {/* FOOTER */}
          <div className="card-footer py-2 d-flex justify-content-between">
            <button
              className="btn btn-sm btn-secondary"
              disabled={currentIndex === 0}
              onClick={() => setCurrentIndex((p) => p - 1)}
            >
              ← Previous
            </button>

            <button
              className="btn btn-sm btn-primary"
              disabled={currentIndex === questions.length - 1}
              onClick={() => setCurrentIndex((p) => p + 1)}
            >
              Next →
            </button>
          </div>
        </div>
      </div>

      {/* ===== SCROLLBAR (RANGE SLIDER) ===== */}
      <div className="container mt-3">
        <input
          type="range"
          className="form-range"
          min="0"
          max={questions.length - 1}
          value={currentIndex}
          onChange={(e) => setCurrentIndex(Number(e.target.value))}
        />

        <div className="text-center fw-bold">
          Question {currentIndex + 1} of {questions.length}
        </div>
      </div>
    </>
  );
};

export default Setftestexammodule;
